import React from 'react';
import styled from 'styled-components';
import {
  ToggleButton as MuiButtonBase,
  ToggleButtonProps,
  Tooltip,
} from '@mui/material';

const ToggleIconButton = styled(MuiButtonBase)`
  gap: 8px;
  color: ${({ theme }) => theme.palette.common.gray2};
  border-radius: 8px !important;
  display: flex;
  justify-content: center;
  align-items: center;

  /* Icon-only selection tiles need more room than regular buttons */
  &.MuiToggleButton-sizeSmall {
    width: 32px;
    height: 32px;
    padding: 4px;
    min-width: 32px;
    min-height: 32px;
  }

  &.MuiToggleButton-sizeMedium {
    width: 40px;
    height: 40px;
    padding: 8px;
    min-width: 40px;
    min-height: 40px;
  }

  &.MuiToggleButton-sizeLarge {
    width: 48px;
    height: 48px;
    padding: 12px;
    min-width: 48px;
    min-height: 48px;
  }

  :hover {
    filter: grayscale(0) !important;
    background-blend-mode: normal !important;
    background-color: unset;
    border: 1.5px solid ${({ theme }) => theme.palette.common.red} !important;
  }

  &.Mui-selected {
    background-color: unset;
    filter: grayscale(0);
    background-blend-mode: normal;
    color: ${({ theme }) => theme.palette.common.gray2};
    border: 1.5px solid ${({ theme }) => theme.palette.common.red} !important;

    /* Default box-shadow (applied when no size class is present) */
    box-shadow: 0 1px 3px 0 ${({ theme }) => theme.palette.common.gray11},
      0 4px 8px 3px ${({ theme }) => theme.palette.common.gray14};

    /* Size-specific box shadows */
    &.MuiToggleButton-sizeSmall {
      box-shadow: 0 1px 2px 0 ${({ theme }) => theme.palette.common.gray11},
        0 2px 4px 2px ${({ theme }) => theme.palette.common.gray14};
    }

    &.MuiToggleButton-sizeMedium {
      box-shadow: 0 1px 3px 0 ${({ theme }) => theme.palette.common.gray11},
        0 3px 6px 2px ${({ theme }) => theme.palette.common.gray14};
    }

    &.MuiToggleButton-sizeLarge {
      box-shadow: 0 1px 3px 0 ${({ theme }) => theme.palette.common.gray11},
        0 4px 8px 3px ${({ theme }) => theme.palette.common.gray14};
    }

    :hover {
      background-color: unset;
    }
  }
`;

type TooltipToggleButtonProps = {
  title: string;
  children: React.ReactNode;
} & ToggleButtonProps;

const SegmentedButton = React.forwardRef(
  (
    { children, title, size = 'medium', ...props }: TooltipToggleButtonProps,
    ref: any,
  ) => (
    <Tooltip title={title}>
      <ToggleIconButton ref={ref} size={size} {...props}>
        {children}
      </ToggleIconButton>
    </Tooltip>
  ),
);

export default SegmentedButton;
